<div class="container">
  <div class="row">

    <div class="col-12 col-md-12 col-lg-12 col-xl-12 p-0 mt-0 mb-0 unq  ">
      <div class="card">
        <!---Title-->
        <div class="row d-flex p-3 m-0 border-bottom">
          <div class="heading_1  mr-auto">{{data.title}}</div>
        </div>
        <form class="form" [formGroup]="formData">
          <!---row loop-->
          <div class="row p-3 m-0 border-bottom">
            <div class="col-12 p-0 mb-2">
              <div class="row ">

                <div class="col-12 col-md-4 col-lg-4 ">
                  <div class="pr-2">
                    <div><span class="secondaryInfo">User Name *</span></div>
                    <input style="width:301px" type="text" class="form-control" placeholder="Enter User Name"
                      formControlName="UserName" [matAutocomplete]="partner"
                      (input)="getFilteredValues($event.target.value)" (onfocus)="getFilteredValues('')">
                    <mat-autocomplete autoActiveFirstOption #partner="matAutocomplete"
                      (optionSelected)='setUserEmail($event.option.id)'>
                      <mat-option *ngFor="let partner of filteredValues" [id]="partner.employeeId"
                        [value]="partner.name">
                        {{partner.name}} ({{partner.employeeId}})
                      </mat-option>
                    </mat-autocomplete>
                    <div *ngIf="formData.get('UserName').touched || flag">
                      <mat-error class="errorFont" *ngIf="formData.get('UserName').errors?.required">
                        User Name is Required
                      </mat-error>
                    </div>
                  </div>
                </div>

                <div class="col-12 col-md-4 col-lg-4">
                  <div class="pr-2">
                    <div><span class="secondaryInfo">Email *</span></div>
                    <input type="text" class="form-control" formControlName='Email' placeholder="Email">
                  </div>
                </div>

                <div class="col-12 col-md-4 col-lg-4 ">
                  <div class="pr-2"><span class="secondaryInfo">Role *</span></div>
                  <mat-select class="form-control" placeholder="Select" formControlName="Role"
                    (selectionChange)="updateRole($event)">
                    <mat-option *ngFor="let role of roles" [value]="role.id">{{role.name}}
                    </mat-option>
                  </mat-select>
                  <div *ngIf="formData.get('Role').touched || flag">
                    <mat-error class="errorFont" *ngIf="formData.get('Role').errors?.required">
                      Role is Required
                    </mat-error>
                  </div>
                </div>

              </div>
              <div class="row " *ngIf="checkSuperAdmin()" style="margin-top: 1rem;">
                <div class="col-12 col-md-4 col-lg-4">
                  <div class="pr-2"><span class="secondaryInfo">Organization *</span></div>
                  <mat-select class="form-control" placeholder="Select" formControlName="Organization"
                    (selectionChange)="updateOrganizations($event)">
                    <mat-option *ngFor="let organization of organizations" [value]="organization.id">
                      {{organization.name}}
                    </mat-option>
                  </mat-select>
                  <div *ngIf="formData.get('Organization').touched || flag">
                    <mat-error class="errorFont" *ngIf="formData.get('Organization').errors?.required">
                      Organization is Required
                    </mat-error>
                  </div>
                </div>

                <!-- <div class="col-md-2 col-xs-2 checkboxes">

                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" formControlName="Mail" class="custom-control-input" id="customCheck3">
                     <label class="custom-control-label w-100 cursor-pointer" for="customCheck3"> Restrict
                      Mail</label> 
                  </div>
                </div> -->
                <div class="col-12 col-md-4 col-lg-4 checkboxes">

                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" formControlName="downloadAndMail" class="custom-control-input"
                      id="customCheck2">
                    <label class="custom-control-label w-90 cursor-pointer" for="customCheck2">Restrict Download
                    </label>
                  </div>
                </div>

                <div class="col-12 col-md-4 col-lg-4 ">
                  <div class="pr-2"><span class="secondaryInfo">View organizations </span></div>
                  <mat-select class="form-control" [(ngModel)]="orgs" placeholder="Select"
                    (selectionChange)="selected($event)" formControlName="SelectAllOrganizations" multiple>
                    <mat-checkbox class="selectAllcheckbox" [value]="'selectAll'" [checked]="ischecked"
                      (change)="selectAll($event)"><label class="selectAllLabel">Select All</label></mat-checkbox>
                    <mat-option [disabled]="organization.id == formData.controls['Organization'].value"
                      *ngFor="let organization of organizationTags" [value]="organization">
                      {{organization.name}}
                    </mat-option>
                  </mat-select>
                </div>

              </div>
              <div class="col-12 d-flex p-0 mt-4 justify-content-center">

              </div>


              <div class="col-12 d-flex p-0 justify-content-center">

                <div class="buttons_column  p-0" style="margin-left: auto; margin-top: 1rem;">
                  <button type="button" class="btn btn-custom_primary ml-2 mr-2 color-orange " id="inv_setup_save"
                    data-backdrop="static" data-keyboard="false" (click)="onSubmit()">Save Changes</button>
                  <button type="button" class="btn btn-custom_primary ml-2 mr-2 " id="inv_setup_cancel"
                    data-backdrop="static" data-keyboard="false" (click)="cancel()">{{'Cancel'}}</button>
                </div>

              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>